import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/views/Index'
import About from '@/components/views/About'
import Contact from '@/components/views/Contact'
// import Terms from '@/components/views/Terms'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Index,
      meta: {
        nav: true,
        title: 'Welcome Home'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        nav: true,
        title: 'About Wisteria Lodge'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        nav: true,
        title: 'Contact Us'
      }
    }
    // {
    //   path: '/terms',
    //   name: 'Terms of Use',
    //   component: Terms,
    //   meta: {
    //     nav: false
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js